import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ToggleSwitch } from '@/components/ui/toggle-switch'
import { useDesignVersionToggle } from '@/hooks'
import { buildCsvFilename, downloadCsv } from '@/utils/file'

import { selectTrainers } from '../../../reducers/Organisation/organisationStaffReducer'
import ToggleField from '../../FormLegacy/FormFieldsV2/ToggleField'
import Icon from '../../Icons'

import OrganisationStaffForm from './OrganisationStaffForm'
import OrganisationStaffList from './OrganisationStaffList'

// TODO: remove this legacy master/detail page (and the Redux organisationStaff slice it feeds) once the new design is fully rolled out
const OrganisationStaff = ({ trainers }) => {
  const { t } = useTranslation(['organisation'])
  const navigate = useNavigate()
  const params = useParams()
  const [searchQuery, setSearchQuery] = useState('')
  const [onlyActive, setOnlyActive] = useState(false)

  const { redirect, toggle: handleUIToggle } = useDesignVersionToggle({
    group: 'staff',
    screen: 'Staff',
    to: { path: '/dashboard/organisation/staff' },
    version: 'legacy',
  })

  const downloadCSVList = (e) => {
    e.preventDefault()
    const fields = [
      { label: t('organisation:staff.list.csv.firstName'), value: 'user.firstName' },
      { label: t('organisation:staff.list.csv.lastName'), value: 'user.lastName' },
      { label: t('organisation:staff.list.csv.email'), value: 'user.email' },
      { label: t('organisation:staff.list.csv.phone'), value: 'phone' },
      { label: t('organisation:staff.list.csv.address'), value: 'street' },
      { label: t('organisation:staff.list.csv.apartmentNumber'), value: 'apartment' },
      { label: t('organisation:staff.list.csv.zipCode'), value: 'zipCode' },
    ]

    downloadCsv({
      data: trainers,
      fields,
      filename: buildCsvFilename({
        page: 'organisation',
        date: new Date(),
      }),
    })
  }

  if (redirect) return redirect

  return (
    <div className="columns">
      <div className="ctp-organisation__design-toggle">
        <ToggleSwitch
          falsyLabel={t('organisation:staff.list.designToggle.old')}
          truthyLabel={t('organisation:staff.list.designToggle.new')}
          checked={false}
          onChange={handleUIToggle}
        />
      </div>
      <div className="column">
        <div className="ctp-short-toolbar-wrapper">
          <button
            className="button button-primary"
            onClick={() => navigate('/dashboard/organisation/staff/legacy/new')}
          >
            {t('organisation:shared.actions.addNew')}
          </button>
          <button
            className="button button-gray has-icon ctp-toolbar__csv"
            onClick={downloadCSVList}
          >
            <Icon icon="download" />
            {t('organisation:staff.list.csv.buttonLabel')}
          </button>
          <div className="ctp-short-toolbar-search">
            <input
              type="text"
              placeholder={t('organisation:staff.list.searchPlaceholder')}
              autoComplete="off"
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Icon icon="search" />
          </div>
          <div className="ctp-toolbar__my-activties">
            <ToggleField
              name="only-active"
              label={t('organisation:staff.list.onlyActive')}
              value={onlyActive}
              onChange={() => setOnlyActive(!onlyActive)}
            />
          </div>
        </div>
        <OrganisationStaffList searchQuery={searchQuery} onlyActive={onlyActive} />
      </div>
      <div className="column">
        <OrganisationStaffForm params={params} />
      </div>
    </div>
  )
}

OrganisationStaff.propTypes = {
  trainers: PropTypes.array,
}

export default connect((state) => ({
  trainers: selectTrainers(state),
}))(OrganisationStaff)
